// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"b7e9c668","50":"48d1fba3","180":"48d1fba3","237":"48d1fba3","467":"48d1fba3","535":"fa8183e9","552":"bfce7075","595":"9b5998bd","718":"48d1fba3"}[chunkId] + ".chunk.css";
};